import { type DealFormDataWithTargeting, dealFormField } from '@openx/types/deal.ts';
import { useWatchDebounce } from '@openx/utils/hooks/useWatchDebounce.ts';
import isEmpty from 'lodash/isEmpty';
import { useFormContext, useWatch } from 'react-hook-form';
import { DealGroupContainer } from '../../../components/DealGroup/DealGroupContainer.tsx';

type IdGroupPreviewProps = {
  disabled: boolean;
};

export const IdGroupPreview = ({ disabled }: IdGroupPreviewProps) => {
  const {
    formState: { errors },
  } = useFormContext<DealFormDataWithTargeting>();

  const externalDealId = useWatchDebounce<DealFormDataWithTargeting, 'external_deal_id'>({
    name: dealFormField.EXTERNAL_DEAL_ID,
  })!;

  const hasErrors = !isEmpty(errors[dealFormField.EXTERNAL_DEAL_ID]);
  const shouldRender = !!externalDealId && !disabled;

  const group =
    useWatch<DealFormDataWithTargeting, typeof dealFormField.METADATA_GROUP_DEAL>({
      name: dealFormField.METADATA_GROUP_DEAL,
    }) || [];

  const loading = !!externalDealId && !hasErrors && !disabled && group.length === 0;

  if (!shouldRender) return null;

  return <DealGroupContainer group={group} dealId={externalDealId} loading={loading} />;
};
